import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

  const HomeDashboard = WithErrorBoundary(
    'dashboard',
    'Error en Home Dashboard - General',
    React.lazy(() => import('./HomeDashboard.container')),
  ) 


 

  const AdminDashboard = WithErrorBoundary(
    'dashboard',
    'Error en Dashboard - Admin',
    React.lazy(() => import('./AdminDashboard')),
  )


  export default {
    path: '/dashboard',
    name: 'dashboard',
    childRoutes: [
      { path: 'general', name: 'generalDashboard', component: HomeDashboard, isIndex : true },
      { path: 'presupuestos', name: 'presupuestosDashboard', component: HomeDashboard },
      { path: 'solicitud-venta', name: 'solicitudVentaDashboard', component: HomeDashboard },
      { path: 'facturacion', name: 'facturacionDashboard', component: HomeDashboard },      
      { path: 'stock', name: 'stockDashboard', component: HomeDashboard },      
      { path: 'admin', name: 'dashboard', component: AdminDashboard },
    ],
  }